import { useCallback, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import LoginModal from "@/features/authentication/components/login-modal";
import useClientQueryString from "@/hooks/use-client-query-string";

function InternalLoginModal() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isAuthenticated } = useAuth();
  const clientQs = useClientQueryString();
  const prevAppRef = useRef<string>("");
  const returnURLRef = useRef<string>("");

  prevAppRef.current = clientQs.getByKey("applicationReference") ?? "";
  returnURLRef.current = clientQs.getByKey("postLoginRedirectionUrl") ?? "";

  const isInternalLogin = pathname.includes("internal-login");

  const navigateToPrevPage = useCallback(() => {
    if (returnURLRef.current) {
      navigate(returnURLRef.current, { replace: true });
      return;
    }

    const isInvalidAppRef =
      prevAppRef.current === "null" || !prevAppRef.current;

    navigate(
      `/?${new URLSearchParams({
        ...(!isInvalidAppRef && {
          applicationReference: prevAppRef.current,
        }),
      })}`,
      { replace: true },
    );
  }, [navigate]);

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      navigateToPrevPage();
    }
  };

  if (!isInternalLogin || isAuthenticated) return null;

  return <LoginModal onOpenChange={handleOpenChange} />;
}

export default InternalLoginModal;
